import { render, staticRenderFns } from "./SongSearchBar.vue?vue&type=template&id=2384a594"
import script from "./SongSearchBar.vue?vue&type=script&lang=ts"
export * from "./SongSearchBar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports